import { useEffect } from 'react';
import ReactGA from 'react-ga';
import { useLocation } from 'react-router';

const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (!import.meta.env.VITE_GA_UA_ID) {
      return;
    }

    ReactGA.pageview(location.pathname);
  }, [location.pathname]);
};

export default useAnalytics;
